import { render } from "./QuranManzilCard.vue?vue&type=template&id=b97a9b56"
import script from "./QuranManzilCard.vue?vue&type=script&lang=js"
export * from "./QuranManzilCard.vue?vue&type=script&lang=js"
script.render = render

export default script